export default "__VITE_ASSET__Ce3i$SeH__"